import login from '@/api/login'

class TokenRefresher {
  TOKEN_CREATED_AT_KEY = 'token-created-at'

  async checkToken (to, next) {
    if (!to.meta.requiresAuth) {
      return next()
    }

    if (to.query.invalidToken) {
      return next()
    }

    const tokenCreatedAtString = localStorage.getItem(this.TOKEN_CREATED_AT_KEY)

    if (!tokenCreatedAtString) {
      return this._redirectToLogin(next)
    }

    const tokenCreated = Date.parse(tokenCreatedAtString)
    const diff = Date.now() - tokenCreated

    if (diff > 252000000) { // mais de 70 horas
      return this._redirectToLogin(next)
    }

    if (diff < 900000) { // menos de 15 minutos
      return next()
    }

    const tokenRecreated = await this._refreshToken()

    if (!tokenRecreated) {
      return this._redirectToLogin(next)
    }

    this.registerToken()

    return next()
  }

  registerToken () {
    const now = new Date().toISOString()
    localStorage.setItem(this.TOKEN_CREATED_AT_KEY, now)
  }

  unregisterToken () {
    localStorage.removeItem(this.TOKEN_CREATED_AT_KEY)
  }

  async _refreshToken () {
    try {
      const result = await login.revitalizarToken()
      return result && result.data && result.data.data && result.data.data.sucesso
    } catch (e) {
      return false
    }
  }

  _redirectToLogin (next) {
    return next({ name: 'FormValidaContexto', query: { invalidToken: true } })
  }
}

export default new TokenRefresher()
